import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectAuthProvider } from 'features/member/reducer/memberDetailSlice';
import { getUtcUSFormatDateWithTime } from 'modules/utils/time';

import AccordionBox from 'components/memberdetail/detail/AccordionBox';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';

import { AuthProvider as AuthProviderType } from 'types/member';
import { TableCell } from 'types/common/table';

import * as S from './AuthProvider.styled';

const AuthProvider = () => {
  const authProviderList = useSelector(selectAuthProvider);

  const authProviderColumns: TableCell<AuthProviderType>[] = [
    {
      align: 'center',
      width: '50%',
      name: 'Auth Provider',
      key: 'providerName',
      render: (rowData: AuthProviderType) => <S.UpperText>{rowData.authProviderName}</S.UpperText>,
    },
    {
      align: 'center',
      name: 'Registered Date',
      key: 'registeredDate',
      render: (rowData: AuthProviderType) =>
        getUtcUSFormatDateWithTime(rowData.registrationDate, true),
    },
  ];

  return (
    <AccordionBox title={'Auth Provider'} margin={'15px 0 0 0'} name={'authProvider'}>
      <DataTableLayout
        customTitleComponent={<S.TotalCount>total {authProviderList?.length}</S.TotalCount>}
      >
        <DataTableHeader header={authProviderColumns} />
        <NewDataTableBody dataList={authProviderList} columns={authProviderColumns} />
      </DataTableLayout>
    </AccordionBox>
  );
};

export default AuthProvider;
